export function showLogin(showLogin) {
  return { type: "SHOW_LOGIN", showLogin };
}
